module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-2.70fc9fe4.png";